// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, connectDatabaseEmulator } from "firebase/database"; // Import for Firebase Realtime Database
import { getAuth, connectAuthEmulator } from "firebase/auth"; // Import for FirebaseAuth
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCkuzk2m51WsK8IKBQujNntN95ASwzMW1o",
  authDomain: "falcon-ride-ee3fb.firebaseapp.com",
  databaseURL: "https://falcon-ride-ee3fb-default-rtdb.firebaseio.com",
  projectId: "falcon-ride-ee3fb",
  storageBucket: "falcon-ride-ee3fb.firebasestorage.app",
  messagingSenderId: "19811799734",
  appId: "1:19811799734:web:4f4209d672638dbb620c17",
  measurementId: "G-44LE8YNMMD"
};

// Local testing only: `REACT_APP_USE_EMULATORS=true npm start` points the site
// at the Firebase emulators on this machine instead of the live project. Never
// set in production builds.
const useEmulators = process.env.REACT_APP_USE_EMULATORS === "true";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
if (!useEmulators) getAnalytics(app); // page-view analytics, live site only
const database = getDatabase(app); // Initialize Firebase Realtime Database
const auth = getAuth(app); // Initialize FirebaseAuth
if (useEmulators) {
  connectDatabaseEmulator(database, "127.0.0.1", 9000);
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectStorageEmulator(getStorage(app), "127.0.0.1", 9199);
  connectFunctionsEmulator(getFunctions(app), "127.0.0.1", 5001);
}
